import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { handle, PlatformType } from "@dp/common";
import DPServices from "@dp/services";
import { makeObservable, observable, reaction, runInAction } from "mobx";
import Base from "./Base";
import OrderStatusModel, { ORDER_STATUS } from "./models/OrderStatusModel";
var OrderStatus = (_class = /*#__PURE__*/function (_Base) {
  _inherits(OrderStatus, _Base);

  var _super = _createSuper(OrderStatus);

  function OrderStatus(rootStore) {
    var _this$rootStore, _this$rootStore$user, _this$rootStore2, _this$rootStore2$user;

    var _this;

    _classCallCheck(this, OrderStatus);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderStatusModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.analyticsModel = (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;
    _this.orderStatusModel = new OrderStatusModel(_this.rootStore.platformUtil);
    _this.analyticsModel = (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.analyticsModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OrderStatus, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = session;

        _this2.orderStatusModel.setSessionDetails(session);
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._appAttributes = appAttributes;
                this.orderStatusModel.setAppAttributesData(appAttributes);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processAppAttributes(_x) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "logoutReset",
    value: function () {
      var _logoutReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function logoutReset() {
        return _logoutReset.apply(this, arguments);
      }

      return logoutReset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this3 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this3.rootStore.common.appAttributes
        };
      }, function (data) {
        _this3._processAppAttributes(data.appAttributes);
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this3.rootStore.user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this3._processSessionDetails(data.sessionDetails);

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "loadCheck",
    value: function () {
      var _loadCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(tkn) {
        var _this4 = this;

        var isRefreshFlow,
            _checkSummary$orderSu,
            _yield$handle,
            _yield$handle2,
            checkError,
            checkSummary,
            orderStatus,
            _checkSummary$orderSu2,
            _yield$handle3,
            _yield$handle4,
            restaurantError,
            restaurant,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                isRefreshFlow = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;

                if (!tkn) {
                  _context7.next = 27;
                  break;
                }

                this.orderStatusModel.setIsCheckSummaryLoading(true);
                _context7.next = 5;
                return handle(DPServices.Curbside.getCheckSummary(tkn));

              case 5:
                _yield$handle = _context7.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                checkError = _yield$handle2[0];
                checkSummary = _yield$handle2[1];
                orderStatus = checkSummary === null || checkSummary === void 0 ? void 0 : (_checkSummary$orderSu = checkSummary.orderSummary) === null || _checkSummary$orderSu === void 0 ? void 0 : _checkSummary$orderSu.orderStatus;

                if (!checkError) {
                  _context7.next = 14;
                  break;
                }

                this.appMessages.showError("Something went wrong", "", null, {
                  undismissible: true,
                  okBtnText: "Ok",
                  okBtnOnClick: function okBtnOnClick() {
                    return _this4._redirectToHome();
                  }
                });
                _context7.next = 25;
                break;

              case 14:
                this.orderStatusModel.setCheckSummaryData(checkSummary);

                if (isRefreshFlow) {
                  _context7.next = 23;
                  break;
                }

                _context7.next = 18;
                return handle(DPServices.Curbside.getRestaurantDetailsByNumber(checkSummary === null || checkSummary === void 0 ? void 0 : (_checkSummary$orderSu2 = checkSummary.orderSummary) === null || _checkSummary$orderSu2 === void 0 ? void 0 : _checkSummary$orderSu2.locationNumber));

              case 18:
                _yield$handle3 = _context7.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                restaurantError = _yield$handle4[0];
                restaurant = _yield$handle4[1];

                if (restaurantError) {// handle error
                } else {
                  this.analyticsModel.setRestaurantDetailData(restaurant);
                  this.orderStatusModel.setRestaurantData(restaurant);
                }

              case 23:
                this.orderStatusModel.setIsCheckSummaryLoading(false);

                if (orderStatus === ORDER_STATUS.CANCEL || orderStatus === ORDER_STATUS.CHECK_CANCELLED) {
                  this.appMessages.showError("Your order was Cancelled", "", null, {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      return _this4._redirectToHome();
                    }
                  });
                }

              case 25:
                _context7.next = 28;
                break;

              case 27:
                this.appMessages.showError("Something went wrong", "", null, {
                  undismissible: true,
                  okBtnText: "Ok",
                  okBtnOnClick: function okBtnOnClick() {
                    return _this4._redirectToHome();
                  }
                });

              case 28:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loadCheck(_x3) {
        return _loadCheck.apply(this, arguments);
      }

      return loadCheck;
    }()
  }, {
    key: "_redirectToHome",
    value: function _redirectToHome() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$rootStore3;

        (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : _this$rootStore3.platformUtil.redirectToURL("/home");
      }
    }
  }]);

  return OrderStatus;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class);
export { OrderStatus as default };